import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import { TableHeader, TableHeaderCell, TextLabel } from "@opensea/ui-kit"
import { head } from "es-toolkit/array"
import { useTranslations } from "use-intl"
import { CancelOrderTableHeaderFragment } from "./CancelOrderTableHeader.fragment"
import { CANCEL_ORDER_TABLE_COLUMN_CLASSNAMES } from "./constants"

type Props = {
  orders: FragmentOf<typeof CancelOrderTableHeaderFragment>[]
}

export const CancelOrderTableHeader = ({ orders: orderKeys }: Props) => {
  const t = useTranslations("wallet.CancelOrderTableHeader")
  const orders = orderKeys.map(orderKey =>
    readFragment(CancelOrderTableHeaderFragment, orderKey),
  )
  const side = head(orders)?.side

  if (!side) {
    return null
  }

  const isListing = side === "LISTING"

  return (
    <TableHeader className="bg-transparent">
      <TableHeaderCell className={CANCEL_ORDER_TABLE_COLUMN_CLASSNAMES.item}>
        <TextLabel size="xs" weight="semibold">
          {isListing
            ? t("listingCount", { count: orders.length })
            : t("offerCount", { count: orders.length })}
        </TextLabel>
      </TableHeaderCell>
      <TableHeaderCell className={CANCEL_ORDER_TABLE_COLUMN_CLASSNAMES.price}>
        <TextLabel size="xs" weight="semibold">
          {isListing ? t("listingPrice") : t("offerPrice")}
        </TextLabel>
      </TableHeaderCell>
    </TableHeader>
  )
}
